import { Low } from './Low'
import lodashes from 'lodash-es'
import lodash from 'lodash'

export class LowWithLodash<T> extends Low<T> {
  chain: lodash.ExpChain<this['data']> = lodashes.chain(this).get('data')
}
